import React, { useState, useCallback } from 'react';
import UserBasedNotificationForm from './UserBasedNotificationForm';
import UserNotificationHistory from './UserNotificationHistory';

function UserBasedNotification() {
    const [refreshHistory, setRefreshHistory] = useState(true);

    const refreshNotificationList = useCallback(async (flag) => {
        setRefreshHistory(flag);
    }, []);

    return (
        <>
            <UserBasedNotificationForm refresh={(flag) => refreshNotificationList(flag)} />
            <br />
            <UserNotificationHistory
                refreshHistory={refreshHistory}
                refresh={(flag) => refreshNotificationList(flag)}
            />
        </>
    );
}

export default UserBasedNotification;
